import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import * as C from './styles';
import CarouselLoad from './load';

export default function Carouselmovies({ movies }) {
console.log(movies)
  const [redirectToDetails, setRedirectToDetails] = useState(false);

  const navigate = useNavigate();

  const [ movie, setMovie ] = useState();

  useEffect(() => {
    if (movies && movies?.movies?.length > 0) {
      // Filtrando os filmes onde a propriedade "main_movie" for verdadeira
      const mainMovies = movies?.movies?.filter(movie => movie.main_movie == true);
    console.log(mainMovies)
      if (mainMovies.length > 0) {
        // Escolhendo um filme aleatório
        const randomMovie = mainMovies[Math.floor(Math.random() * mainMovies.length)];
        setMovie(randomMovie);
      }
    }
  }, [movies]);

  useEffect(() => {
      const mediaQuery = window.matchMedia('(max-width: 800px)');
  
      const handleMediaChange = (e) => {
        if (e.matches) {
          setRedirectToDetails(true)
        } else {
          setRedirectToDetails(false)
        }
      };
  
      // Adiciona o listener de mudanças na mídia
      mediaQuery.addEventListener('change', handleMediaChange);
  
      // Verifica o estado inicial da tela
      if (mediaQuery.matches) {
        handleMediaChange(mediaQuery);
      }
  
      // Remove o listener quando o componente é desmontado
      return () => mediaQuery.removeEventListener('change', handleMediaChange);
  }, []);

  return (
    <C.Container className="carousel-container">
      {(movies?.movies?.length > 0 && movie?.id_imdb) ?
      <C.Content>
      <div className='background-image-main' style={{backgroundImage: `url(https://image.tmdb.org/t/p/w200/${movie?.background_path})`}}></div>
          <C.ContainerImage>
            <C.Image src={`https://image.tmdb.org/t/p/original/${movie?.background_path}`}/>
            <div className='container-age-rating'>
              <section className='age-rating'>
                <span className={`span-classificacao-movie-principal span-classificacao-indicativa-${movie?.age_rating?.age}`}>{movie?.age_rating?.age == '0' ? "L" : movie?.age_rating?.age}</span>
              </section>
            </div>
          </C.ContainerImage>
          <C.Details background={movie?.background_button_watch} text_color={movie?.color_button_watch}>
            <div className="div-details">
              <header>
                  <span>{movie?.media_type == 'tv' ? "Série" : "Filme"}</span>
                  <span>{(movie?.release_date)?.slice(0, 4)}</span>
                  <span><i className="fas fa-star"></i> {movie?.vote_average?.toFixed(1) || 5}<small>/10</small></span>
              </header>
              <h1 className="title">{movie?.name}</h1>
              {!movie?.can_watch_on?.includes('web') ?
                <p className='available-on-app'><i className='fas fa-exclamation-triangle'></i> Disponível apenas no app!</p>
                : null
              }
              <p className='overview'>{movie?.overview}</p>
              <section className='section-bt-watch-movie'>
                  <Link to={`/details/${movie?.media_type}/${movie?.id_tmdb}/${movie?.id_imdb}?watch=true`} className='bt-watch-movie watch-button'><i className='fas fa-play'></i> <span className='span-assistir-movie-principal'>Assitir</span></Link>
                  <Link to={`/details/${movie?.media_type}/${movie?.id_tmdb}/${movie?.id_imdb}`} className='bt-watch-movie details-button'><i className='fas fa-info-circle'></i> <span className='span-assistir-movie-principal'>Detalhes</span></Link>
                  {/*
                  <Link to={`/preview/${movie?.media_type}/${movie?.id}/`} className='bt-watch-movie bt-details-movie'><i className='fas fa-info-circle'></i> <span className='span-assistir-movie-principal'>{idioma == 'ingles' ? 'Details' : 'Detalhes'}</span></Link>
                    */}
              </section>
            </div>
          </C.Details>
        </C.Content>
        : <CarouselLoad/>
      }
    </C.Container>
  );
};
